/* eslint-disable newline-per-chained-call */
/**
 * 基础使用
 */
import { Breadcrumb, Loading } from '@roo/roo'
import React, { FC } from 'react'
import styles from './index.module.less'
import { useLocation, useNavigate } from 'react-router'


interface IProps{
  loading?: boolean
  title: string
  parentTitle?: string
  /** 点击面包屑父级时的自定义导航回调，不传则默认返回上级路径 */
  onParentClick?: () => void
  children: React.ReactNode
}
const DetailPageWraper: FC<IProps> = (props:IProps) => {
  const jumpParentPage = useJumpParentPage()
  const menus = [{
    text: props.parentTitle,
    icon: 'home',
    onClick: props.onParentClick ?? jumpParentPage,
  }, {
    text: props.title,
  }]

  return (
    <div className={styles['detail-page-wraper']}>
      {props.loading && (<Loading fullscreen visible backdrop text=" " />)
      }
      <div className={styles['detail-page-titlebar']}>
        <Breadcrumb items={menus} style={{ marginBottom: 0 }}/>
      </div>
      <div className={styles['detail-page-body']}>
        <div className={styles['detail-page-content']}>
          {props.children}
        </div>
        <div className={styles['detail-page-footer']} id="detail-page-footer"/>
      </div>
    </div>
  )
}

export const useJumpParentPage = () => {
  const navigate = useNavigate()
  const hashLocation = useLocation()
  return () => navigate(hashLocation.pathname.split('/').slice(0, -1).join('/'))
}


export default DetailPageWraper